module.exports = __webpack_public_path__ + "img/Milad_Rahatianpur_verbeterd.b96da087.jpg";